import React from 'react'
import { NavLink } from 'react-router-dom'
import BetaBadge from './BetaBadge'

const utilityLinkClassName = 'text-zinc-300 transition-colors hover:text-zinc-100'

const Footer = () => {
    return (
        <footer className="border-t border-zinc-800/80 bg-zinc-950 text-zinc-300">
            <div className="mx-auto max-w-screen-lg px-4 py-5 custom-lg:px-0 sm:py-6">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex items-center gap-3">
                        <div className="text-sm font-semibold tracking-[0.14em] text-zinc-100">
                            WINRATES.GG™
                        </div>
                        <BetaBadge />
                        <div className="text-[11px] text-zinc-300 sm:text-xs">
                            The unified League of Legends® stats companion app — For Winners.
                        </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] sm:text-xs">
                        <NavLink className={utilityLinkClassName} to="/">
                            Home
                        </NavLink>
                        <NavLink className={utilityLinkClassName} to="/contact">
                            Contact
                        </NavLink>
                        <NavLink className={utilityLinkClassName} to="/faq">
                            FAQ
                        </NavLink>
                        <a className={utilityLinkClassName} href="https://www.riotgames.com/en/legal">
                            Legal Jibber Jabber
                        </a>
                    </div>
                </div>

                <div className="mt-4 space-y-1.5 border-t border-zinc-800/80 pt-4 text-[11px] leading-5 text-zinc-300 sm:text-xs">
                    <p>© 2024 WINRATES.GG™ (WR.GG) — the unified League of Legends® companion app and registered trademark.</p>
                    <p>WINRATES.GG™ is not endorsed by Riot Games® and does not reflect the views or opinions of Riot Games®.</p>
                    <p>Riot Games® and all associated properties are trademarks or registered trademarks of Riot Games, Inc.</p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
